import React from "react";
import {Route} from "react-router-dom";
import Members from "../../views/member/members";
import RequireAuthentication from "../../hoc/authentication/requireAuthentication";
import {sessionStore} from "../../utils/sessionStore";
import {Authorizations, hasAuthorization} from "../../utils/authorizations";

let routes = [];
const applications = sessionStore.get("applications");
const authorizations = sessionStore.get("authorizations") ?? [];

if (
    applications
    && (applications["marketplace"] || applications["picking"])
    && hasAuthorization(authorizations, Authorizations.GLOBAL_MEMBER_MANAGEMENT)
) {
    routes.push([
        <Route
            path="/members/:params"
            component={RequireAuthentication(Members)}
            exact
            key="member"
        />,
    ])
}

export default routes;
